/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateSageIntacctTimesheetsInput = {
    People?: Array<SageTimesheetInput | null> | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type SageTimesheetInput = {
    SageEmployeeId?: string | null | undefined;
    StartDate?: string | null | undefined;
    Name?: string | null | undefined;
    TimeRegs?: Array<SageTimesheetEntryInput | null> | null | undefined;
};
export type SageTimesheetEntryInput = {
    TimeRegId?: string | null | undefined;
    Date?: string | null | undefined;
    Hours?: number | null | undefined;
    Billable?: boolean | null | undefined;
    Notes?: string | null | undefined;
    SageProjectId?: string | null | undefined;
    SageTaskId?: string | null | undefined;
    SageLocationId?: string | null | undefined;
    SageDepartmentId?: string | null | undefined;
};
export type CreateSageIntacctTimesheetsMutationVariables = {
    input: CreateSageIntacctTimesheetsInput;
};
export type CreateSageIntacctTimesheetsMutationResponse = {
    readonly createSageIntacctTimesheets: {
        readonly viewer: {
            readonly id: string;
        } | null;
    } | null;
};
export type CreateSageIntacctTimesheetsMutation = {
    readonly response: CreateSageIntacctTimesheetsMutationResponse;
    readonly variables: CreateSageIntacctTimesheetsMutationVariables;
};



/*
mutation CreateSageIntacctTimesheetsMutation(
  $input: CreateSageIntacctTimesheetsInput!
) {
  createSageIntacctTimesheets(input: $input) {
    viewer {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateSageIntacctTimesheetsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSageIntacctTimesheetsPayload",
    "kind": "LinkedField",
    "name": "createSageIntacctTimesheets",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateSageIntacctTimesheetsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateSageIntacctTimesheetsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateSageIntacctTimesheetsMutation",
    "operationKind": "mutation",
    "text": "mutation CreateSageIntacctTimesheetsMutation(\n  $input: CreateSageIntacctTimesheetsInput!\n) {\n  createSageIntacctTimesheets(input: $input) {\n    viewer {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'fb49b2d39ddecd8e3500e65268b6fdae';
export default node;
